
import React from 'react';
import { Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

interface FavoriteButtonProps {
  isFavorite: boolean | undefined;
  isLoading?: boolean;
  onToggle: (e: React.MouseEvent) => void;
}

const FavoriteButton = ({ isFavorite, isLoading, onToggle }: FavoriteButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      className={`rounded-full w-8 h-8 ${
        isFavorite ? 'text-red-500' : 'text-gray-500 hover:text-gray-700'
      }`}
      onClick={onToggle}
      disabled={isLoading}
    >
      <Heart size={18} className={isFavorite ? 'fill-red-500 text-red-500' : ''} />
    </Button>
  );
};

export default FavoriteButton;
